/* eslint-disable react-hooks/exhaustive-deps */
import { appConfig } from '@common/config';
import useClickAway from '@hook/useClickAway';
import { type IServer, type IServerList } from '@interface/ICommon';
import { ServerListQueryKey, WorldServerListQueryKey } from '@network/queryKeys';
import { useDataQuery } from '@network/querys';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ServerDropdown = ({ props }: { props: IServerDDProp }) => {
    const { submitCallback, defaultSvrId, changeSvrId, tradableWorld, useAllSvrBtn, useWorldSvr } = props;
    const { t } = useTranslation();
    const { data: serverList } = useDataQuery<IServerList[]>(
        ServerListQueryKey,
        `/${appConfig.service}/v2.0/game/server`,
        {},
        {
            staleTime: Infinity,
        }
    );
    const { data: serverListW } = useDataQuery<IServer[]>(
        WorldServerListQueryKey,
        `/${appConfig.service}/v2.0/game/market/world`,
        {},
        {
            staleTime: Infinity,
            enabled: useWorldSvr,
        }
    );

    const [isOpen, setIsOpen] = useState(false);
    const [svrList, svrListSet] = useState<IServerList[]>([]);
    const [svrList2d, svrList2dSet] = useState<IServer[]>([]);
    const [nowSelect, nowSelectSet] = useState({ d1: 0, d2: Number(defaultSvrId), title: t('noti.allservers') });

    useEffect(() => {
        if (!serverList || serverList.length < 1) return;
        if (useWorldSvr && !serverListW) return;

        if (serverList.length < 1) return;

        serverList.forEach((item) => (item.worldId ||= getRandomInt(50000, 99999)));

        let servers = [...serverList];
        if (useWorldSvr && serverListW) {
            servers = [
                {
                    worldName: t('price.worldexchange'),
                    worldId: 0,
                    servers: serverListW,
                },
                ...servers,
            ];
        }

        svrListSet(servers);
        settting(servers);
    }, [serverList, serverListW]);

    useEffect(() => {
        if (appConfig.now === 'noti' && tradableWorld) {
            const dat = findWorldIdByServerId(nowSelect.d2, svrList);
            if (dat) {
                selectComplete(dat.id.toString(), svrList[0].servers, {
                    d1: 0,
                    d2: dat.id,
                    title: t('price.worldexchange') + ' : ' + dat.name,
                });
            }
        }
    }, [tradableWorld, svrList]);

    useEffect(() => {
        if (svrList.length < 1 || changeSvrId === null) return;

        if (changeSvrId === 'all') {
            svrList2dSet(svrList[0].servers);
            nowSelectSet({ d1: 0, d2: 0, title: t('noti.allservers') });
            return;
        }

        const dat = findWorldIdByServerId(Number(changeSvrId), svrList);
        if (dat) {
            const list = findObjectByWorldId(svrList, dat.id);
            if (list) {
                nowSelectSet((current) => ({
                    ...current,
                    d1: dat.id,
                    d2: Number(changeSvrId),
                    title: dat.name + ' : ' + findServerNameById(Number(changeSvrId), list.servers),
                }));
                svrList2dSet(list.servers);
            }
        }
    }, [changeSvrId]);

    const settting = (servers: IServerList[]) => {
        const dat = findWorldIdByServerId(nowSelect.d2, servers);
        if (dat) {
            const list = findObjectByWorldId(servers, dat.id);
            if (list) {
                selectComplete(
                    nowSelect.d2.toString(),
                    list.servers,
                    {
                        d1: dat.id,
                        title: dat.name + ' : ' + findServerNameById(nowSelect.d2, list.servers),
                    },
                    true
                );
            }
        } else {
            if (useAllSvrBtn) {
                selectComplete('all', servers[0].servers, { d1: 0, d2: 0, title: t('noti.allservers') }, true);
            } else {
                const d2id = servers[0].servers[0].serverId;
                const d2name = servers[0].servers[0].serverName;
                selectComplete(
                    d2id.toString(),
                    servers[0].servers,
                    {
                        d1: servers[0].worldId,
                        d2: d2id,
                        title: servers[0].worldName + ' : ' + d2name,
                    },
                    true
                );
            }
        }
    };

    const d1Click = (_wid: number) => {
        const list = findObjectByWorldId(svrList, _wid);
        if (list) {
            svrList2dSet(list.servers);
            nowSelectSet((current) => ({ ...current, d1: _wid }));
        }
    };

    const d2Click = (_sid: number, _sname: string) => {
        const dat = findWorldIdByServerId(_sid, svrList);
        if (dat) {
            selectComplete(_sid.toString(), undefined, {
                d1: dat.id,
                d2: _sid,
                title: dat.name + ' : ' + _sname,
            });
        }
    };

    const allClick = () => {
        selectComplete('all', svrList[0].servers, { d1: 0, d2: 0, title: t('noti.allservers') });
    };

    const selectComplete = (
        _d: string,
        svr?: IServer[],
        selObj?: {
            d1?: number;
            d2?: number;
            title: string;
        },
        isFirstSetting: boolean = false
    ) => {
        setIsOpen(false);
        if (svr) svrList2dSet(svr);
        if (selObj)
            nowSelectSet((current) => ({
                ...current,
                ...selObj,
            }));
        submitCallback(_d, isFirstSetting);
    };

    const wrapRef = useRef<HTMLDivElement>(null);
    useClickAway(wrapRef, (e) => {
        setIsOpen(false);
    });

    return (
        <div className="ui-dropdown-wrap dropdown-2depth">
            <div className={classNames({ 'is-active': isOpen }, 'ui-dropdown ui-dropdown-community')}>
                <div className="select" onClick={() => setIsOpen(!isOpen)}>
                    <span className="selectedCategory" data-areas="__서버_클릭">
                        {nowSelect.title}
                    </span>
                </div>
                <div className="option option-2depth" ref={wrapRef}>
                    {useAllSvrBtn && (
                        <div className="option-menu option-menu-all" onClick={allClick}>
                            {t('noti.allservers')}
                        </div>
                    )}
                    <div className="option-menu option-menu-1depth">
                        <ul className="option-list">
                            {svrList.map((svr, idx) => (
                                <li
                                    key={svr.worldId + '_' + idx}
                                    className={classNames({ 'is-active': nowSelect.d1 === svr.worldId }, 'depth1')}
                                    onClick={() => d1Click(svr.worldId)}
                                >
                                    {svr.worldName}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="option-menu option-menu-2depth">
                        <ul className="option-list menu2depthList">
                            {svrList2d.map((svr, idx) => (
                                <li
                                    key={svr.serverId + '_' + idx}
                                    className={classNames({ 'is-active': nowSelect.d2 === svr.serverId }, 'depth2')}
                                    onClick={() => d2Click(svr.serverId, svr.serverName)}
                                >
                                    {svr.serverName}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export interface IServerDDProp {
    submitCallback: (_d: string, _isFirstSetting?: boolean) => void;
    defaultSvrId: string | undefined;
    changeSvrId: string | null;
    tradableWorld: boolean | undefined;
    useAllSvrBtn: boolean;
    useWorldSvr: boolean;
}

const getRandomInt = (min: number, max: number): number => Math.floor(Math.random() * (max - min + 1)) + min;

const findObjectByWorldId = (svrlist: IServerList[], worldId: number): IServerList | undefined => {
    return svrlist.find((obj) => obj.worldId === worldId);
};

const findWorldIdByServerId = (serverId: number, svrlist: IServerList[]): { id: number; name: string } | null => {
    const foundItem = svrlist.find((item) => item.servers.some((server) => server.serverId === serverId));
    return foundItem ? { id: foundItem.worldId, name: foundItem.worldName } : null;
};

const findServerNameById = (serverId: number, svrlist: IServer[]): string | undefined => {
    const foundServer = svrlist.find((server) => server.serverId === serverId);
    return foundServer?.serverName;
};
